import IntlService from 'ember-intl/services/intl';
import moment from 'moment-timezone';
import Formats from 'volta/formats';
import CustomFieldDefinition from 'volta/models/custom-field-definition';
import { ICustomFieldTableColumn, TFieldType } from 'volta/models/types/customFieldDefinition';

import Helper from '@ember/component/helper';
import { observer } from '@ember/object';
import { inject as service } from '@ember/service';
import { isPresent } from '@ember/utils';

export default class CustomFieldFormatHelper extends Helper {
  onLocaleChange = observer('intl.locale', () => {
    this.recompute();
  });

  @service declare intl: IntlService;

  compute(
    [value, column = {}]: [number | string | boolean | string[], Partial<CustomFieldDefinition>],
    { emptyText }: { emptyText?: string }
  ) {
    if (!isPresent(value)) {
      return emptyText;
    }

    const {
      numberFormat = 'DECIMAL',
      dateFormat = 'L',
      fieldConstraints = {},
      formula = {}
    } = column as CustomFieldDefinition & ICustomFieldTableColumn;

    let { fieldType } = column as CustomFieldDefinition & ICustomFieldTableColumn;

    if (fieldType === 'FORMULA') {
      fieldType = (fieldConstraints.resultType ?? formula.resultType) as TFieldType;
    }

    if (fieldType === 'NUMBER') {
      return this.intl.formatNumber(numberFormat === 'PERCENT' ? +value / 100.0 : +value, {
        ...Formats.number[numberFormat]
      });
    } else if (fieldType === 'DATE') {
      return moment(value as moment.MomentInput).format(dateFormat);
    } else if (fieldType === 'ARRAY' && Array.isArray(value)) {
      return value.length ? value.join(', ') : emptyText;
    } else if (fieldType === 'BOOLEAN') {
      return this.intl.t(value ? 'yes' : 'no');
    }

    return value;
  }
}
